// Post-Offer confirmation page.
// Reads ?handle=<product-handle> from the URL, fetches the product
// from Shopify's products.js endpoint, and injects the featured image
// at the top of the page. If the handle is missing or the fetch fails,
// the image block stays hidden so the rest of the page renders cleanly.
(function () {
  'use strict';

  var section = document.querySelector('[data-post-offer]');
  if (!section) return;

  var watch = section.querySelector('[data-post-offer-watch]');
  var img = section.querySelector('[data-post-offer-watch-image]');
  if (!watch || !img) return;

  var handle;
  try {
    handle = new URLSearchParams(window.location.search).get('handle');
  } catch (e) {
    handle = null;
  }
  if (!handle) return;

  fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
    .then(function (res) {
      if (!res.ok) throw new Error('product fetch failed: ' + res.status);
      return res.json();
    })
    .then(function (product) {
      var src = product.featured_image || (product.images && product.images[0]);
      if (!src) return;
      // products.js returns protocol-relative URLs ("//cdn.shopify..."); leave as-is.
      img.src = src;
      img.alt = product.title || '';
      watch.hidden = false;
    })
    .catch(function () {
      // Silent fail — block stays hidden, page is still usable.
    });

  // Wire mode only: ?wire_amount=<dollars> is appended by bid-modal.js on
  // successful wire submit. Absent entirely on offer/source confirmations,
  // so this element stays hidden for those flows — purely additive.
  var wireAmountEl = section.querySelector('[data-post-offer-wire-amount]');
  if (wireAmountEl) {
    var wireAmountRaw;
    try {
      wireAmountRaw = new URLSearchParams(window.location.search).get('wire_amount');
    } catch (e) {
      wireAmountRaw = null;
    }
    if (wireAmountRaw) {
      var wireAmountNum = parseFloat(wireAmountRaw);
      if (!isNaN(wireAmountNum) && wireAmountNum > 0) {
        var formatted = wireAmountNum.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        wireAmountEl.textContent = 'Bank Wire Amount: $' + formatted;
        wireAmountEl.hidden = false;
      }
    }
  }
})();
